import { Controller } from "@hotwired/stimulus"
import { getApplication } from '../app';

export default class extends Controller {
    static targets = [
        "groupsTitle",
        "groups",
        "coupons",
        "couponsTitle",
        "paymentType"
    ]

    connect() {
        this.initPaymentTypeSelection();
    }

    initPaymentTypeSelection() {
        if (!this.hasPaymentTypeTarget) return;

        const paymentTypeBlocks = this.paymentTypeTargets;

        paymentTypeBlocks.forEach(block => {
            block.addEventListener('click', (event) => {
                const radio = block.querySelector('input[type="radio"]');

                if (radio) {
                    radio.checked = true;

                    paymentTypeBlocks.forEach(b => b.classList.remove('selected'));

                    block.classList.add('selected');

                    const changeEvent = new Event('change');
                    radio.dispatchEvent(changeEvent);

                    this.element.dispatchEvent(new CustomEvent('payment-type-changed', {
                        detail: { value: radio.value }
                    }));
                }
            });

            const radio = block.querySelector('input[type="radio"]');
            if (radio && radio.checked) {
                block.classList.add('selected');
            }
        });
    }

    async remove(event) {
        const target  = event.currentTarget;
        const type    = target.dataset.type;
        const index   = target.dataset.index;
        const id      = target.dataset.id;
        const groupID = target.dataset.groupId || '';

        const couponPriceController = getApplication().getControllerForElementAndIdentifier(
            document.querySelector('[data-controller~="coupon-price"]'),
            'coupon-price'
        );

        const wasDiscountActive = couponPriceController?.discountActive || false;

        this.removeItemFromDom(type, index, id, groupID, target);

        if (wasDiscountActive) {
            await couponPriceController.recalculateAfterRemoval();
        }
    }

    removeItemFromDom(type, index, id, groupID, target) {
        let selector = `[data-type="${type}"][data-index="${index}"][data-id="${id}"]`;
        if (groupID) {
            selector += `[data-group-id="${groupID}"]`;
        }

        const item = this.element.querySelector(selector);
        const summaryItem = target.closest('.item-wrapper');
        const priceController = getApplication().getControllerForElementAndIdentifier(this.element, 'contract-price');

        if (summaryItem && priceController) {
            summaryItem.remove();

            if (item) {
                const itemHR = item.nextElementSibling;
                item.remove();

                if (itemHR && itemHR.nodeName === 'HR') {
                    itemHR.remove();
                }
            }

            if (this.hasGroupsTarget && this.groupsTarget.children.length === 0) {
                this.groupsTarget.remove();
                if (this.hasGroupsTitleTarget) {
                    this.groupsTitleTarget.remove();
                }
            }

            if (this.hasCouponsTarget && this.couponsTarget.children.length === 0) {
                this.couponsTarget.remove();
                if (this.hasCouponsTitleTarget) {
                    this.couponsTitleTarget.remove();
                }
            }

            priceController.calculatePriceWithoutRest();

            let key = ''
            switch (type) {
                case 'group':
                    key = `${id}_${groupID}_group`
                    break;
                case 'membership':
                    key = `${id}_membership`
                    break;
                case 'coupon':
                    key = `${id}_coupon`
                    break;
                case 'gift_coupon':
                    key = `${id}_gift_coupon`
                    break;
            }

            const floatingCartData = JSON.parse(localStorage.getItem('__floating_cart') || '{}');
            if (floatingCartData.cart && floatingCartData.cart[key]) {
                delete floatingCartData.cart[key];

                if (Object.keys(floatingCartData.cart).length === 0) {
                    floatingCartData.expiryTime = null;
                }

                localStorage.setItem('__floating_cart', JSON.stringify(floatingCartData));
            }
        }
    }
}
